module.exports = __webpack_public_path__ + "a1a313ce94769c274e105f2ae94cca9f.jpg";